<!--
  mat-datepicker requires an input element to be used,
  it is hidden from the UI and assistive technologies.
-->
<input
  tabIndex="-1"
  aria-hidden="true"
  class="hidden-input"
  [matDatepicker]="picker"
  [value]="startDate"
  (dateChange)="dateChange($event)"
>
<mat-datepicker
  #picker
  vueOverlayOpen
></mat-datepicker>
